const TIMEZONE = 'Asia/Ho_Chi_Minh';

// e.g. 28/05/2026 → 20260528. Đổi mỗi ngày nên page mà carousel bốc cũng đổi mỗi ngày.
//
// PHẢI quy về giờ Việt Nam, KHÔNG lấy giờ máy: `server/utils/homeCarouselSeed.js` tính
// seed theo `Asia/Ho_Chi_Minh` (server chạy UTC) và seed đó nằm trong cache key của khối
// preload. Lấy giờ máy thì khách đặt timezone khác GMT+7 sẽ lệch seed với server SUỐT CẢ
// NGÀY (không chỉ quanh nửa đêm) — preload luôn bị coi là của ngày khác và bị bỏ.
export function getDateSeed(): number {
  // en-CA cho ra khuôn YYYY-MM-DD, ổn định hơn là ghép từng phần.
  const ymd = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());

  const [y, m, d] = ymd.split('-').map(Number);

  return y * 10000 + m * 100 + d;
}
